// Status indicators: light-tinted pill with colored text (Section C)
const STATUS_COLORS = {
  // zinc - Draft / Pending / N/A / Not Started / inactive
  'draft': '#031333', 'pending': '#031333', 'n/a': '#031333', 'na': '#031333',
  'not started': '#031333', 'archived': '#031333', 'new': '#031333', 'open': '#031333',
  'on hold': '#031333', 'closed': '#031333',
  // steel blue - In Progress / Active / Filed / Sent / Filing
  'in progress': '#1B4A76', 'active': '#1B4A76', 'filed': '#1B4A76', 'sent': '#1B4A76',
  'filing': '#1B4A76', 'won': '#16A34A', 'direct': '#1B4A76',
  // amber - Review / Client Reviewing / Awaiting / Submitted
  'review': '#D97706', 'client reviewing': '#D97706', 'awaiting': '#D97706', 'submitted': '#D97706',
  // green - Approved / Completed / Resolved / Accepted / Paid
  'approved': '#16A34A', 'completed': '#16A34A', 'resolved': '#16A34A', 'accepted': '#16A34A', 'paid': '#16A34A',
  // scarlet - Expired / Overdue / Critical / Rejected / Declined / Lost
  'expired': '#E5441A', 'overdue': '#E5441A', 'critical': '#E5441A', 'rejected': '#E5441A',
  'declined': '#E5441A', 'lost': '#E5441A',
  // amber - Pending Renewal
  'pending renewal': '#D97706',
};

export function statusColor(status) {
  if (!status) return '#031333';
  const key = String(status).toLowerCase().trim();
  return STATUS_COLORS[key] || '#71717A';
}

// Light background + colored text pill style (Section C).
// Uses the base color at ~12% alpha for the background and the solid color for the text.
export function pillStyle(color) {
  const c = color || '#71717A';
  return {
    backgroundColor: `${c}1F`,
    color: c,
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '14px',
    fontWeight: 500,
    padding: '2px 10px',
    lineHeight: 1.3,
    whiteSpace: 'nowrap',
    borderRadius: '2px',
  };
}

export default function StatusDot({ status, label, className = '' }) {
  const color = statusColor(status);
  return (
    <span className={`inline-flex items-center ${className}`} style={pillStyle(color)} data-testid="status-dot">
      {label ?? status}
    </span>
  );
}
